import React from 'react';
import './style.css';

// Motivational "Sadaqah Jariyah" (ongoing charity) section that encourages
// people to support building the masjid.
// TODO: This is an introductory teaser. A future release will expand it with
// full hadith references, giving tiers/impact breakdowns, project milestones,
// and an FAQ. Keep the copy aligned with the masjid's messaging.
const SadaqahJariyah = (props) => {
  const benefits = [
    {
      icon: 'fi flaticon-taj-mahal-1',
      title: 'A House in Paradise',
      text: 'The Prophet \u0635 said: \u201cWhoever builds a masjid for Allah, Allah will build for him a house like it in Paradise.\u201d (Bukhari & Muslim)',
    },
    {
      icon: 'fi flaticon-prayer',
      title: 'Reward That Never Ends',
      text: 'Every prayer prayed, every dhikr made, and every gathering held in the masjid keeps earning you reward \u2014 long after your gift.',
    },
    {
      icon: 'fi flaticon-quran',
      title: 'Knowledge for Generations',
      text: 'Children learning the Quran and families growing in faith \u2014 a lasting legacy of beneficial knowledge that flows back to every supporter.',
    },
  ];

  return (
    <div className="sj-area section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="sj-title">
              <span>Sadaqah Jariyah</span>
              <h2>The Charity That Keeps Giving</h2>
              <p>
                Contributing to a masjid is one of the most rewarding forms of
                <strong> sadaqah jariyah</strong> &mdash; ongoing charity whose
                reward continues even after we are gone.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {benefits.map((item, i) => (
            <div className="col-lg-4 col-md-6 col-12" key={i}>
              <div className="sj-card">
                <div className="sj-icon">
                  <i className={item.icon}></i>
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-9">
            <p className="sj-hadith">
              &ldquo;When a person dies, all their deeds end except three:
              ongoing charity (sadaqah jariyah), beneficial knowledge, or a
              righteous child who prays for them.&rdquo;
              <span>&mdash; Prophet Muhammad &#1589; (Muslim)</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SadaqahJariyah;
